import { constArrayIncludes } from '@animavirtuality/utils';

export const ChainIds = [1, 5, 1337] as const;
export type ChainId = (typeof ChainIds)[number];

const readChainIdFromEnvironment = (): ChainId => {
    const value = parseInt(process.env.REACT_APP_CHAIN_ID ?? '1');
    if (isNaN(value) || !constArrayIncludes(ChainIds, value)) {
        return 1;
    }

    return value;
};

export type Address = `0x${string}`;

// Config from .env.cjs
export const chainId: ChainId = readChainIdFromEnvironment();
export const infuraId: string = process.env.REACT_APP_INFURA_KEY ?? '';
export const tokenContractAddress = (process.env.REACT_APP_CONTRACT_ADDRESS ?? '') as Address;
export const escrowContractAddress = (process.env.REACT_APP_ESCROW_CONTRACT_ADDRESS ?? '') as Address;

export const apiBaseUrl: string = process.env.REACT_APP_API_BASE_URL ?? '';
export const buildApiUrl = (path: string): URL => {
    return new URL(`${apiBaseUrl}${path}`);
};

export const recaptchaSiteKey: string = process.env.REACT_APP_RECAPTCHA_KEY ?? '';

export const buildFeaturedBotImgURL = (id: number): string => `assets/img/qr/${chainId}/${id}.png`;
export const featuredBotsJSON = `assets/3d/featured-bots/${chainId}-real.json?v=1`;
export const IPFS_MIRROR = 'https://ipfs-mirror.anima.supply/';
export const buildPublicUrl = (path: string): string => {
    if (path.startsWith('/')) {
        return `assets${path}`;
    }
    return `assets/${path}`;
};

export const BOT_LAYER_TYPES = ['body', 'eye', 'arm', 'leg', 'antenna', 'tail'] as const;
export type BotLayerType = (typeof BOT_LAYER_TYPES)[number];

export const BOT_LAYER_IDS: Record<BotLayerType, number> = {
    body: BOT_LAYER_TYPES.indexOf('body'),
    eye: BOT_LAYER_TYPES.indexOf('eye'),
    arm: BOT_LAYER_TYPES.indexOf('arm'),
    leg: BOT_LAYER_TYPES.indexOf('leg'),
    antenna: BOT_LAYER_TYPES.indexOf('antenna'),
    tail: BOT_LAYER_TYPES.indexOf('tail'),
};

// pulsing button/text values
export const PULSE_PERIOD = 0.75;
export const MIN_OPACITY = 0.05;
export const MAX_OPACITY = 0.6;

export const MOSAIC_TRANSITION_DURATION = 0.6;
export const MAX_VOXEL_COUNT = 4096;

export const BUY_URL = 'https://only.bot/buy';
export const MAGICEDEN_ITEMDETAILS_URL =
    'https://magiceden.io/item-details/ethereum/0xfcf5306ec78088dd85bb484816a1e37161b005e6';
